// src/stone/illustrations/StonjiFaceIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StonjiFaceIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 80 80",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { fill: "#00A868", d: "M0 0h80v80H0z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#20252A",
          d: "M24.997 29.913a5 5 0 1 0 0-9.999 5 5 0 0 0 0 9.999M54.999 29.913a5 5 0 1 0 0-9.999 5 5 0 0 0 0 9.999"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M69.997 40a30.001 30.001 0 0 1-59.998 0h5a25.002 25.002 0 0 0 49.999 0z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M12.5 42.498a2.502 2.502 0 1 0 0-5.005 2.502 2.502 0 0 0 0 5.005M67.5 42.498a2.502 2.502 0 1 0 0-5.004 2.502 2.502 0 0 0 0 5.004"
        }
      )
    ]
  }
);
var StonjiFaceIllustration_default = StonjiFaceIllustration;

export {
  StonjiFaceIllustration,
  StonjiFaceIllustration_default
};
